export const IMPERSONATION_KEYS = {
  FLAG: "impersonating",
  ADMIN_TOKEN: "adminToken",
  ADMIN_REFRESH_TOKEN: "adminRefreshToken",
  ADMIN_ROLE: "adminRole",
  ADMIN_USER: "adminUser",
} as const;

export const isImpersonating = (): boolean =>
  localStorage.getItem(IMPERSONATION_KEYS.FLAG) === "true";
